<template>
  <MixedCarts :dataSource="dataSource" />
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "Onboarding",
  components: {
    MixedCarts,
  },
  data() {
    return {
      elements: ["see_reco", "questions", "christmas_idea"],
      dataSource: {
        type: "bar",
        height: 350,
        series: [],
        chartOptions: {
          colors: ["#E91E63", "#33a5fc", "#33b2df"],
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "80%",
              horizontal: true,
            },
          },
          labels: [],
          dataLabels: {
            enabled: true,
            offsetX: 2,
            theme: "dark",
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            enabled: true,
            theme: "dark",
            style: {
              fontSize: "14px",
              fontFamily: undefined,
            },
            onDatasetHover: {
              highlightDataSeries: false,
            },
            x: {
              show: false,
            },
          },
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  mounted() {
    if (this.onboarding) {
      for (const [key, value] of Object.entries(this.onboarding)) {
        if (this.elements.includes(key)) {
          this.dataSource.series.push({
            name: this.store_config.i18n[this.$i18n.locale].popup[
              `${this.getBtnNames(key)}`
            ],
            data: [value],
          });
          this.dataSource.chartOptions.labels.push(
            this.store_config.i18n[this.$i18n.locale].popup[
              `${this.getBtnNames(key)}`
            ]
          );
        }
      }
    }
  },
  methods: {
    getBtnNames(key) {
      if (key === "see_reco") return "proposition5";
      if (key === "questions") return "proposition4";
      if (key === "christmas_idea") return "proposition6";
      else return key;
    },
  },
};
</script>
